<template>
  <div v-loading="gettingChatRooms">
    <div class="govgr-header__container" style="color: #fff">
      <div class="govgr-header__content">
      <a href="https://www.gov.gr/">
        <img class="govgr-header-logo" src="https://www.gov.gr/gov_gr_logo.svg" />
      </a>
      <a href="https://e-doatap.doatap.gr">
        <img class="govgr-header-secondary-logo" src="../assets/Logo-eDoatap_Color_white-letters.png"/>
      </a>
    </div>
<div class="govgr-phase-banner">
    <el-dialog title="Ειδοποιήσεις - Μηνύματα" v-if="currentUser"
      :visible.sync="chatDialogVisible" width = "95%">
      <Chat />
    </el-dialog>
    <div class="gov-user-box navbar-user hidden-sm-and-down" v-if="currentUser">
      {{translation(activeRole)}}: {{userNameSurname}}
    </div>

    <el-button class="timer-button" v-if="currentUser" @click='refresh'>
      <countdown class="clock" :time = 'prettyTime'></countdown>
    </el-button>

    <span style="padding-right: 20px;" v-if="currentUser">
      <el-badge v-if="haveNewMessages" value="νέα" class="item">
        <el-button :type="notificationsType" icon="el-icon-message" @click="listAllNotifications">
        </el-button>
      </el-badge>
      <el-button v-else :type="notificationsType" icon="el-icon-message" @click="listAllNotifications">
      </el-button>
    </span>

    <span class="navbar-account hidden-xs-and-down">
      <el-select
        v-model="selectedRole"
        filterable
        :placeholder="activeRole"
        v-if="currentUser"
        size="small"
      >
        <el-option v-for="(role, index) in userScope" :key="role" :label="userScopeGr[index]" :value="role">
        </el-option>
      </el-select>
      <el-dropdown v-if="currentUser"  :hide-timeout='500'>
        <i class="el-icon-arrow-down el-icon--right" style="color: #fff">Λογαριασμός</i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <el-button type="text" @click.native.prevent="getProfile">Προφιλ</el-button>
          </el-dropdown-item>
          <el-dropdown-item>
            <el-button type="text" @click.native.prevent="logout">Αποσύνδεση</el-button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <template v-if="activeRole != null && !currentUser">
        <router-link to='/login' @click.native.prevent="login">
          <el-button type="text">Σύνδεση</el-button>
        </router-link>
      </template>
    </span>
</div>

  </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import dictionary from '../store/dictionary'
// import 'element-ui/lib/theme-chalk/display.css'
import Countdown from './common/Countdown'
import Chat from './common/chat/Chat'
import logoImage from '@/assets/logo.png'

export default {
  name: 'Navbar',
  components: {
    dictionary,
    Countdown,
    Chat
  },
  mounted: function () {
  },
  data () {
    return {
      direction: 'rtl',
      chatDialogVisible: false,
      logoImage: logoImage,
      timerNotificationShown: false,
      timer: null,
      time: 3600,
      allNotifications: [],
      loadingNotifications: false,
      pendingNotificationsExist: true
    }
  },
  computed: {
    prettyTime () {
      let time = this.time / 60
      let minutes = parseInt(time)
      let seconds = Math.round((time - minutes) * 60)
      return `${minutes} : ${seconds}`
    },
    notificationsType () {
      return this.pendingNotificationsExist ? 'danger' : 'info'
    },
    selectedRole: {
      get: function () {
        return this.activeRole
      },
      set (newRole) {
        this.$store.dispatch('newRole', newRole)
        if (newRole === 'SpecialProponent') this.$store.dispatch('GET_EXTERNAL_CHATROOMS')
      }
    },
    ...mapGetters({
      userNameSurname: 'userNameSurname',
      currentUser: 'currentUser',
      userScope: 'userScope',
      userScopeGr: 'userScopeGr',
      activeRole: 'activeRole',
      gettingChatRooms: 'gettingChatRooms',
      myChats: 'myChats',
      haveNewMessages: 'haveNewMessages'
    }),
    ...mapState(['pendingNotifications', 'startTimer', 'BASE_URL'])
  },
  methods: {
    handleClose (done) {
      this.$confirm('Are you sure you want to close this?')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    refresh () {
      try {
        this.$store.dispatch('refresh')
        this.time = 3600
      } catch (error) {
        // All Vuex modules must logout here
        this.$store.dispatch('logout')
      }
    },
    getProfile (command) {
      this.$store.dispatch('updateProfile')
    },
    translation (term) {
      return dictionary[term]
    },
    sawNotifications () {
      this.pendingNotificationsExist = false
    },
    listAllNotifications () {
      this.chatDialogVisible = !this.chatDialogVisible
      if (this.activeRole !== 'Auditor') this.$store.dispatch('GET_CHATROOMS')
      if (['SpecialProponent', 'PreChecker'].includes(this.activeRole)) this.$store.dispatch('GET_EXTERNAL_CHATROOMS')
    },
    login () {
    },
    logout () {
      this.$store.dispatch('logout')
    }
  },
  watch: {
    startTimer: function (newVal, oldVal) {
      if (newVal) {
        if (this.time !== 3600) {
          this.time = 3600
        } else if (this.time < 60) {
          this.$notify.warning({
            title: 'Προειδοποίηση',
            message: `Η συνεδρία σας θα λήξει σε ένα λεπτό παρακαλώ πατήστε προσωρινή αποθήκευση 
                      γιατί θα χρειαστεί να επενασυνδεθείται για λόγους ασφαλείας`,
            offset: 100
          })
        }
        this.timer = setInterval(() => {
          if (this.time > 0) {
            this.time--
          } else if (this.time < -5) {
            clearInterval(this.timer)
          } else {
            clearInterval(this.timer)
            this.logout()
          }
        }, 1000)
      } else {
        this.time = -10
      }
    },
    time: function (newVal, oldVal) {
      if (newVal !== -10 && newVal < 120 && !this.timerNotificationShown) {
        this.$notify.warning({
          title: 'Προειδοποίηση',
          message: `Η συνεδρία σας θα λήξει σε δύο λεπτά παρακαλώ πατήστε προσωρινή
                    αποθήκευση γιατί θα χρειαστεί να επανασυνδεθείτε για λόγους ασφαλείας`,
          duration: 0,
          offset: 100
        })
        this.timerNotificationShown = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// .header-logo {
//   float: left;
//   padding-top: 5px;
//   padding-right: 2px;
//   height: 90%;
// }
// .clock {
//   border-radius: 5px 15px;
//   border: 2px solid #7fa3bb;
//   padding: 5px 10px;
// }
// .el-input__inner {
//   width: 200px;
// }
// .el-select {
//   width: 200px;
// }
// .navbar-user {
//   float: center;
//   padding-right: 10px;
// }
// .navbar-account {
//   float: right;
//   padding-right: 10px;
//   height: 100%;
// }
// .el-header, .el-footer {
//   background-color: #B3C0D1;
//   color: #333;
//   text-align: center;
//   padding:10px 20px;
//   -webkit-box-sizing:border-box;
//   box-sizing:border-box;
//   -ms-flex-negative:0;
//   flex-shrink:0;
//   border-radius: 4px;
// }
// .bg-doatap {
//   background: #605B56 !important;
// }
// .btn-logout {
//   background-color: #837A75;
//   border-color: #837A75;
//   color: #fff;
// }
// .btn-logout:hover {
//   background-color: darken(#837A75, 20%);
//   border-color: darken(#837A75, 20%);
//   color: #fff;
// }
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue